export default "__VITE_ASSET__z4GRU2lS__"